var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audio-player-container" }, [
    _c("div", { staticClass: "cta-box", on: { click: _vm.handleCta } }, [
      _vm.showPlay ? _c("span", { staticClass: "icon-play" }) : _vm._e(),
      _vm._v(" "),
      _vm.showPause ? _c("span", { staticClass: "icon-pause" }) : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "lds-ring" }, [
            _c("div"),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c("div"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "controlbar",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.changeSeek.apply(null, arguments)
            },
          },
        },
        [
          _c("div", {
            staticClass: "progress",
            style: "width: " + _vm.progress + "%",
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "description" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("div", {
          staticClass: "duration",
          domProps: { innerHTML: _vm._s(_vm.duration) },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }